import React, { FC } from 'react'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { styled } from '../../../lib/stitches'
import { Box, Spacer } from '../../core/Components'
import { ResponsiveIcons } from '../../core/icons'
import ProfileCard from '../../platform/dashboard/ProfileCard'
import Title from '../../platform/new-explore/components/Title'
import { CompetitionInfoModal } from './components/CompetitionInfoModal'

const HeaderContainer = styled('div', {
  padding: '16px 16px 0px',
  boxSizing: 'border-box',
  borderBottom: '1px solid rgba(0,0,0,.1)',
  backgroundColor: 'white'
})

const segmentCompetitionModals = (button) => {
  window.analytics.track('Button Clicked', {
    button: button
  })
}

interface Props {
  isSticky?: boolean
}

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  variants: {
    col: {
      true: {
        flexDirection: 'column',
        alignItems: 'stretch'
      }
    }
  }
})

const StyledUploadSoundsButton = styled('button', {
  all: 'unset',
  background: 'linear-gradient(93.07deg, #8BACFF -3.71%, #C2ADFC 107.34%)',
  borderRadius: '8px',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '$medium',
  height: '36px',
  color: 'black',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px 32px',
  variants: {
    dark: {
      true: {
        background: '$gray15',
        color: '$gray01'
      }
    }
  },
  '&:hover': {
    opacity: 0.9
  },
  '&:active': {
    opacity: 0.7
  }
})

//need link from Wilton
const SubmitEntryButton: FC = () => {
  return (
    <StyledUploadSoundsButton
      onClick={() => {
        segmentCompetitionModals('Submit Entry')
        window.open('https://bbrkephmpf3.typeform.com/to/AXfMVKSw', '_blank')
      }}
    >
      <ResponsiveIcons.Upload strokeWidth={'1.2px'} />
      <span style={{ marginLeft: '6px' }}>Submit Entry</span>
    </StyledUploadSoundsButton>
  )
}

//need content from Wilton
const CompetitionInfo: FC = () => {
  return (
    <CompetitionInfoModal
      trigger={
        <StyledUploadSoundsButton
          dark
          onClick={() => {
            segmentCompetitionModals('Info Modal')
          }}
        >
          <span style={{ marginLeft: '0px' }}>Info</span>
        </StyledUploadSoundsButton>
      }
    />
  )
}

const Header = React.forwardRef<HTMLDivElement, Props>(({ isSticky }, ref) => {
  const { isBreakpoint } = useWindowSize()

  if (isBreakpoint('tablet'))
    return (
      <HeaderContainer
        css={{
          height: '86px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 48px',
          position: 'sticky',
          zIndex: 10,
          top: 0
        }}
        ref={ref}
      >
        <Box css={{ display: 'flex', alignItems: 'center', flex: 1, height: '100%' }}>
          <Container css={{ justifyContent: 'left', width: '-webkit-fill-available' }}>
            <Title css={{ marginRight: '32px' }}>Competition Entries</Title>
            <CompetitionInfo />
            <Box css={{ width: '8px' }} />
            <SubmitEntryButton />
          </Container>
          <Spacer />
          <ProfileCard css={{ marginLeft: '$32' }} />
        </Box>
      </HeaderContainer>
    )

  return (
    <HeaderContainer css={{ position: 'sticky', top: 0, zIndex: 10 }} ref={ref}>
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title>Competition Entries</Title>
        <ProfileCard />
      </Box>
      <Box css={{ display: 'flex', margin: '8px 0' }}>
        <CompetitionInfo />
        <Box css={{ width: '8px' }} />
        <SubmitEntryButton />
      </Box>
    </HeaderContainer>
  )
})

export default Header
